import * as React from 'react';
import { IndexRoute, Route } from 'react-router';

import ChatPage from 'bundles/help-redirects/components/ChatPage';
import ChatWithUsPage from 'bundles/help-redirects/components/ChatWithUsPage';
import HelpRedirectsApp from 'bundles/help-redirects/components/HelpRedirectsApp';

export default (
  <Route path="hc">
    <IndexRoute component={HelpRedirectsApp} />
    <Route path="chat" component={ChatPage} />
    {/* Do not update the URL below to something like /chat-with-us or /learner-chat because then it will match regex inclusion rules for the floating chat button, which we don't want on this page: */}
    <Route path="lhc-chat" component={ChatWithUsPage} />
    <Route path="*" component={HelpRedirectsApp} />
  </Route>
);
